import { Link } from 'react-router-dom';

export default function BrandIntro() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <span className="inline-block text-xs font-semibold text-accent-700 uppercase tracking-wider bg-accent-100/80 px-3 py-1 rounded-full">
          ACBuySpreadsheet Hub
        </span>

        <h2 className="mt-6 text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
          Track Orders
          <span className="inline-flex items-center mx-2 align-middle">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20designer%20running%20shoe%20with%20vibrant%20coral%20accent%20on%20smooth%20light%20grey%20stone%20surface%2C%20sharp%20directional%20studio%20lighting%20from%20top%20right%2C%20premium%20product%20photography%2C%20dynamic%20athletic%20aesthetic%2C%20crisp%20textile%20details%2C%20modern%20sportswear&width=200&height=200&seq=intro-shoe-v2&orientation=squarish"
              alt="ACBuySpreadsheet shoe tracking"
              className="w-10 h-10 md:w-14 md:h-14 rounded-full object-cover object-top"
            />
          </span>
          <br />
          Calculate Profit
          <span className="inline-flex items-center mx-2 align-middle">
            <img
              src="https://readdy.ai/api/search-image?query=Striking%20emerald%20green%20basketball%20jersey%20with%20gold%20accent%20details%20spread%20flat%20on%20dark%20matte%20surface%2C%20dramatic%20top%20down%20studio%20lighting%2C%20sports%20product%20photography%2C%20bold%20color%20contrast%2C%20premium%20athletic%20fabric%20texture%20visible&width=200&height=200&seq=intro-jersey-v2&orientation=squarish"
              alt="ACBuySpreadsheet profit jersey"
              className="w-10 h-10 md:w-14 md:h-14 rounded-full object-cover object-top"
            />
          </span>
          <br />
          Scale Business
          <span className="inline-flex items-center ml-2 align-middle">
            <img
              src="https://readdy.ai/api/search-image?query=Crystal%20clear%20glass%20perfume%20bottle%20with%20rose%20gold%20cap%20on%20textured%20white%20marble%20surface%2C%20soft%20diffused%20natural%20light%20from%20left%20side%2C%20luxury%20fragrance%20product%20photography%2C%20elegant%20minimalist%20composition%2C%20subtle%20warm%20reflections%2C%20high%20end%20aesthetic&width=120&height=160&seq=intro-perfume-v2&orientation=portrait"
              alt="ACBuySpreadsheet scale perfume"
              className="w-8 h-10 md:w-10 md:h-14 rounded-lg object-cover object-top"
            />
          </span>
        </h2>

        <p className="mt-8 text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
          ACBuySpreadsheet is a structured spreadsheet system designed to help users manage, track, and optimize their ACBuy operations efficiently. It replaces manual tracking with automated calculations, clear dashboards, and scalable data organization.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 bg-primary-500 text-white rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            Get ACBuySpreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <Link
            to="/article/what-is-acbuyspreadsheet"
            className="px-7 py-3 border border-foreground-800 text-foreground-800 rounded-md text-sm font-semibold hover:bg-foreground-800 hover:text-background-50 transition-colors whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            Read SEO Guides
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}